<app-doc-viewer
  title="Draw"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/draw">
    <igo-map-browser [map]="map" [view]="view">
      <div class="map-actions --vertical --bottom --right">
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>

    <igo-draw [stores]="stores" [map]="map" />
  </app-example-viewer>
</app-doc-viewer>
